import {
  useEffect,
  useMemo,
  useState,
} from 'react';
import {
  Filter,
  FilterValue,
} from 'interfaces/filters';
import { useAppDispatch } from './redux';
import { gridHelperActions } from 'store/slices/gridHelper';
import {
  readFiltersFromSessionStorage,
  saveFiltersToSessionStorage,
} from 'utils/sessionStorage';

export const useFilters = (initialFilters: Array<Filter>) => {
  const dispatch = useAppDispatch();
  const [filters, setFilters] = useState<Array<Filter>>(initialFilters);
  const [appliedFilters, setAppliedFilters] = useState<Array<Filter>>([]);

  const setFilter = (
    filterName: string,
    filterValue: FilterValue,
  ) => {
    setFilters((previousFilters) => previousFilters.map((filter) => (filter.name === filterName
      ? { ...filter, value: filterValue }
      : filter)));
  };

  const clearAllFilters = useMemo(() => () => {
    setFilters(initialFilters);
  }, [initialFilters]);

  useEffect(() => {
    const filtersFromLocalStorage = readFiltersFromSessionStorage();
    setFilters(filtersFromLocalStorage?.length ? filtersFromLocalStorage : initialFilters);
  }, [initialFilters]);

  useEffect(() => {
    const filtersToApply = filters.filter((filter) => (filter.value.length || filter.value.hasOwnProperty('value1') > 0));
    setAppliedFilters(filtersToApply);
    dispatch(gridHelperActions.setFiltering(filtersToApply.reduce((obj, item) => ({ ...obj, [item.name]: item.value }), {})));
    saveFiltersToSessionStorage(filtersToApply);
  }, [dispatch, filters]);

  return {
    filters,
    setFilter,
    setFilters,
    clearAllFilters,
    appliedFilters,
  };
};
